export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/dj_drops_tags.0e81969.svg";